/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import AudiosService from "../Services/Audios";
import AuthorsService from "../Services/Authors";
import WithoutLyrics from "../Images/audiolyrics.svg";
import WithLyrics from "../Images/audiowithoutlyrics.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Reset from "../Images/reset.png";
import ListPagination from "../Components/ListPagination";
import "../Styles/Audios.css";
import "../Styles/Sidebar.css";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import $ from "jquery";
import imgpause from "../assets/audioPlayer/img/yellowplay.svg";
import { useUser } from "../Contexts/UserContext";
import imgdownload from "../Images/downloadpravachan.svg";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { LogInModel } from "./LoginModel";
import { SideBar } from "./SubMenu";
import Loader from "./Loader";

const AudiosPage = () => {
  const { isSelected } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [audios, setAudios] = useState<any[] | undefined>(undefined);

  const [refresh, setRefresh] = useState(false);

  const [SortValue, setSortValue] = useState("3");

  const [categories, setCategories] = useState<any[]>([]);
  const [CategoryId, setCategoryId] = useState("");
  const [Lyrics, setLyrics] = useState<any>("");
  const [LyricsId, setLyricsId] = useState<any>("");
  const [Singer, setSinger] = useState<any>("");
  const [SingerId, setSingerId] = useState<any>("");

  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleItemClick = (index: any) => {
    setActiveIndex(index);
  };

  var timestamp = new Date().getTime();
  const encoded = btoa(timestamp.toString());

  const [pagination, setPagination] = useState({
    pageNo: 0,
    recordsPerPage: 12,
    totalRecords: 0,
  });

  const [logIn, setLogIn] = useState<boolean>(false);
  const [clickedAudio, setClickedAudio] = useState<{audio: any, index: number} | null>(null);

  const closeModal = () => {
    setLogIn(false);
    setClickedAudio(null);
  };
  const UserIdentity = localStorage.getItem("Token") as any;
  const location = useLocation();

  const [loginState, setLoginState] = useState<boolean>(false);

  const handleLoginStateChange = async (newState: any) => {
    setLoading(true); // Show loader

    setLoginState(newState === true);
    localStorage.setItem("type", "audios");

    // Navigate only to the specific audio that was clicked
    if (newState === true && clickedAudio) {
      const { audio, index } = clickedAudio;
      navigate(`/audios/${audio.slug}`, {
        state: {
          audioId: audio.id,
          audioslug: audio.slug,
          sorting: SortValue,
          pageNum: pagination.pageNo,
          index: index,
          audiocat: CategoryId,
          audioAuthor: state?.authorId || SingerId
        },
      });
    }

    setLoading(false); // Hide loader after navigation
  };

  const state = location.state as {
    authorId: string;
    authorName: string;
    type: string;
    audiocat: string;
    audioAuthor: string;
  };

  const catId: any = localStorage.getItem("categoryId") || CategoryId || state?.audiocat;
  const autId: any = localStorage.getItem("authorId") || SingerId || state?.authorId;
  const sort: any = localStorage.getItem("sort") || SortValue;

  const [bread, showBread] = useState<string>("");
  const [disableChildColored, setDisableChildColored] = useState(false);
  const [resetClicked, setResetClicked] = useState(false);
  const [isSelecteditem, setIsSelecteditem] = useState<boolean>(false);

  function ResetData() {
    setDisableChildColored(false);
    setCategoryId("");
    setSingerId("");
    setLyricsId("");
    setSortValue("3");
    setActiveIndex(null);
    localStorage.removeItem("categoryId");
    localStorage.removeItem("authorId");
    localStorage.removeItem("sort");
    setPagination({
      ...pagination,
      pageNo: 0,
    });
    setResetClicked(true); // Trigger reset (this will remove highlighted item color)
    setTimeout(() => setResetClicked(false), 50);
    setRefresh(true);
    // window?.location?.reload();
  }

  function ClickOnFilter(
    SingerId: string,
    CategoryId: string,
    LyricsId: number
  ) {
    setRefresh(false);
    AudiosService.getAudios(
      0,
      pagination.recordsPerPage,
      false,
      CategoryId || state?.audiocat || catId,
      SingerId || state?.authorId || autId,
      "",
      SortValue || sort,
      "",
      window.location.pathname === "/audios/special" ? true : false,
      state?.type || "audios",
      LyricsId,
      "",
      "",
      ""
    ).then((res) => {
      if (res) {
        setAudios(res.result?.items);
        setPagination({
          ...pagination,
          pageNo: 1,
          totalRecords: res.result?.totalRecords,
        });
      }
    });
  }

  const downloadAudio = (audioPath: any) => {
    const imageUrl = audioPath;
    const link = document.createElement('a');
    link.href = imageUrl; link.download = 'image.jpg';
    document.body.appendChild(link); link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    ClickOnFilter(SingerId, CategoryId, LyricsId);
    $(".CategoryList > ul > li > div").removeClass("listActive");
    $("#cat-" + CategoryId).addClass("listActive");

    $(".Authorlist > ul > li > div").removeClass("listActive");
    $("#sin-" + SingerId).addClass("listActive");
    if (LyricsId === "") {
      $(".LanguageList > ul > li > div").removeClass("listActive");
      $("#lan-" + 0).addClass("listActive");
    }
    if (LyricsId === "lyrics0") {
      $(".LanguageList > ul > li > div").removeClass("listActive");
      $("#lan-" + 1).addClass("listActive");
    }
  }, [SingerId, CategoryId, LyricsId]);

  useEffect(() => {
    AudiosService.getFilters("audio").then((res) => {
      if (res.status) {
        setSinger(res.result.authors);
        setLyrics(res.result);
      }
    });
  }, [i18n.language]);

  useEffect(() => {
    AudiosService.getAudioCategories().then((res) => {
      if (res.status) {
        setCategories(res.result);
      }
    });
  }, [i18n.language]);

  useEffect(() => {
    ResetData();
  }, [isSelected]);

  useEffect(() => {
    setRefresh(false);
    const fetchData = async () => {
      try {
        const response = await AudiosService.getAudios(
          pagination.pageNo === 0
            ? 0
            : pagination.recordsPerPage * pagination.pageNo - 12,
          pagination.recordsPerPage,
          false,
          catId,
          autId,
          "",
          sort,
          "",
          window.location.pathname === "/audios/special" ? true : false,
          state?.type || "audios",
          LyricsId,
          "",
          "",
          UserIdentity
        )
        const res = await response;
        setAudios(res.result?.items);
        setPagination({
          ...pagination,
          totalRecords: res.result?.totalRecords,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Hide loader after fetching
      }
    }
    fetchData();
  }, [refresh, SortValue, i18n.language, CategoryId, SingerId, loginState]);

  const handleAudioClick = (audio: any, i: number) => {
    console.log("naviage-from-audio-page",state);
    
    localStorage.setItem("type", "audios");
    if (localStorage.getItem("Token")) {
      navigate(`/audios/${audio?.slug}`, {
        state: {
          audioId: audio.id,
          audioslug: audio.slug,
          sorting: SortValue,
          pageNum: pagination.pageNo,
          index: i,
          audiocat: CategoryId,
          audioAuthor: state?.authorId || SingerId,
        },
      });
    } else {
      // Store the clicked audio data for after login
      setClickedAudio({ audio, index: i });
      setLogIn(true);
    }
  };

  useEffect(() => {
    AuthorsService.GetAuthorDataById(state?.authorId, "").then((res) => {
      showBread(res?.result?.name);
    });
  }, [i18n.language, refresh]);

  useEffect(() => {
    if (CategoryId !== "") {
      setSortValue("0")
    }
  }, [CategoryId])

  useEffect(() => {
  }, [localStorage.getItem("Token"), UserIdentity])

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageNo: 1   // 👈 reset to first page
    }));
    setRefresh(true); // 👈 trigger fresh API call
  }, [CategoryId, SingerId, LyricsId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="breadcrumbs-head newcontainer audios-header">
        <div className="breadcrumbs">
          <div className="containers audio-header-container">
            {state?.authorName ? (
              <label>{bread}</label>
            ) : window.location.pathname === "/audios/special" ? (
              t("Special_Audios_tr")
            ) : (
              t("Audios_tr")
            )}
            <div className="breadcrumb-links">
              <Link to="/">{t("Home_tr")}</Link>
              {state?.authorName ? (
                <Link
                  to={"/author/ + "}
                  state={{
                    authorId: state?.authorId,
                    authorName: state?.authorName,
                  }}
                  className="author-breadcrumb"
                >
                  / {bread}
                </Link>
              ) : (
                ""
              )}
              <span className="current-page-breadcrumb">
                /{" "}
                {window.location.pathname === "/audios/special"
                  ? t("Special_Audios_tr")
                  : t("Audios_tr")}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="fontfamily audios-page-container">
        <div className="containers">
          <div className="gst-page-content pagecontentbackground">
            <div className="row">
              <div className="col-lg-3">
                <div className="sidebar-container">
                  <div>
                    <div className="cardbackground filter-header">
                      <span className="boxheadtitle">{t("Filter_tr")}</span>
                      {(SingerId !== "" || CategoryId !== "" || LyricsId !== "" || pagination.pageNo > 1) && (
                        <img
                          alt="reset"
                          src={Reset}
                          className="resetimg"
                          onClick={() => {
                            // window?.location?.reload();
                            setIsSelecteditem(false);
                            ResetData();
                          }}
                        />
                      )}
                    </div>

                    <div className="filter-options-container">
                      {/* audio list */}
                      <Accordion
                        defaultExpanded
                        elevation={0}
                        className="filter-accordion"
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className="filter-accordion-summary"
                          style={{
                            background: "#fffaec",
                            height: "0px",
                            minHeight: "25px",
                            marginTop: "15px"
                          }}
                        >
                          <h2 className="filtertitle audio-list-title">
                            {t("audioList_tr")}
                          </h2>
                        </AccordionSummary>

                        <AccordionDetails className="filter-accordion-details">
                          <div>
                            <SideBar
                              setIsSelecteditem={setIsSelecteditem}
                              isSelectedItem={isSelecteditem}
                              items={categories!}
                              onClick={(value: any) => {
                                if (value) {
                                  if (value.items === null)
                                    setCategoryId(value.id);
                                }
                              }}
                              disableChildColored={false}
                            // onRefresh={ResetData}
                            />
                          </div>
                        </AccordionDetails>
                      </Accordion>
                      {/* Preacher  */}
                      <Accordion
                        elevation={0}
                        className={`filter-accordion ${state?.authorId ? "hidden-accordion" : ""
                          }`}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className="filter-accordion-summary preacher-summary"
                          style={{ background: "#fffaec" }}
                        >
                          <h2 className="filtertitle">{t("Singer_tr")}</h2>
                        </AccordionSummary>
                        <AccordionDetails className="filter-accordion-details preacher-details">
                          {Singer && Singer.length > 0
                            ? Singer?.map((Singer: any) => (
                              <div
                                key={`c-${Singer.id}`}
                                className="Authorlist"
                                onClick={() => {
                                  setSingerId(Singer.id);
                                }}
                              >
                                <ul className="author-list-ul">
                                  <li>
                                    <div
                                      id={`sin-${Singer.id}`}
                                      className="author-name"
                                    >
                                      {Singer.name}
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            ))
                            : ""}
                        </AccordionDetails>
                      </Accordion>
                      {/* lyrics & without lyrics */}
                      <Accordion elevation={0} className="filter-accordion">
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          className="filter-accordion-summary lyrics-summary"
                          style={{ background: "#fffaec" }}
                        >
                          <h2 className="filtertitle">{t("Lyrics_tr")}</h2>
                        </AccordionSummary>

                        <AccordionDetails className="filter-accordion-details lyrics-details">
                          <div className="">
                            <div className="LyricsList">
                              <ul className="lyrics-type-list">
                                <li
                                  key={1}
                                  onClick={() => {
                                    handleItemClick(1);
                                    setLyricsId(1);
                                  }}
                                >
                                  <div
                                    className={`lyrics-option ${activeIndex === 1 ? "active-lyrics" : ""
                                      }`}
                                  >
                                    {t("Lyrics_tr")}
                                  </div>
                                </li>
                                <li
                                  key={2}
                                  onClick={() => {
                                    handleItemClick(2);
                                    setLyricsId(2);
                                  }}
                                >
                                  <div
                                    className={`lyrics-option ${activeIndex === 2 ? "active-lyrics" : ""
                                      }`}
                                  >
                                    {t("Without_Lyrics_tr")}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                <div className="detailbg audios-list-container">
                  <div className="sidebarmargin">
                    <div className="align-items-center row">
                      <div className="col-6">
                        <div className="filter1 total-records-container">
                          <span className="total-records-text">
                            {t("Total_Records_tr")} : {pagination.totalRecords}
                          </span>
                        </div>
                      </div>
                      <div className="filter1 col-6 sort-container">
                        <div className="filter1 sort-options">
                          <span>{t("Sort_tr")}</span>
                          <select
                            value={SortValue}
                            onChange={(e) => {
                              setSortValue(e.target.value);
                            }}
                            className="sort-select"
                          >
                            <option value="0">{t("General_tr")}</option>
                            <option value="3">{t("Popular_tr")}</option>
                            <option value="2">{t("Latest_tr")}</option>
                            <option value="1">{t("Title_tr")}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  {audios && audios.length > 0 ? (
                    <div>
                      {audios.map((audio, i) => (
                        <div key={`audio-${audio.id}`}>
                          <div className="sidebarmargin">
                            <div
                              className="audiosBox"
                              onClick={() => handleAudioClick(audio, i)}
                            >
                              {/* ICON */}
                              <div className="audio-item-icon">
                                <img
                                  className="audioicon"
                                  src={
                                    audio.lyricsHash != null && audio.lyricsHash !== ""
                                      ? WithLyrics
                                      : WithoutLyrics
                                  }
                                  onError={(e) => {
                                    e.currentTarget.src = WithoutLyrics;
                                  }}
                                  alt={audio.name}
                                  title={audio.name}
                                />
                              </div>

                              {/* TEXT */}
                              <div className="audio-item-text">
                                <p className="audio-item-title">
                                  {audio.name != null &&
                                    audio.name.length > 100
                                    ? audio.name.slice(0, 80) + "..."
                                    : audio.name}
                                </p>
                                {audio.description && (
                                  <label className="audio-item-description">
                                    {audio.description}
                                  </label>
                                )}
                                <label className="audio-item-length">
                                  {audio.audioLength}
                                </label>
                              </div>

                              {/* BUTTONS */}
                              <div className="btns">
                                <div className="buttonres">
                                  <a
                                    id="download"
                                    title="Download"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (localStorage.getItem("Token")) {
                                        downloadAudio(
                                          audio.audioPath != null
                                            ? audio.audioPath +
                                            "?t=" +
                                            encoded +
                                            "&download_attachment=true"
                                            : "no record found"
                                        );
                                      } else {
                                        setLogIn(true);
                                      }
                                    }}
                                  >
                                    <img
                                      alt="download"
                                      src={imgdownload}
                                      className="downloadbtn"
                                    />
                                  </a>
                                </div>

                                <div className="audio-play-button-container">
                                  <img
                                    alt="Play"
                                    title="Play"
                                    src={imgpause}
                                    className="playbtn"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div
                        className={`col-12 pagination-container ${pagination.totalRecords <= 12 ? "hidden-pagination" : ""
                          }`}
                      >
                        <ListPagination
                          totalRecords={pagination.totalRecords}
                          recordsPerPage={pagination.recordsPerPage}
                          currentPage={pagination.pageNo}
                          onClick={(p) => {
                            setPagination({
                              ...pagination,
                              pageNo: p,
                            });
                            setRefresh(true);
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="ebooks-category resultnotfound">
                      {audios?.length === 0 ? (
                        <label>{t("result_not_found_tr")}</label>
                      ) : (
                        <div>
                          {loading && <Loader loading={loading} />}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
      <LogInModel opens={logIn} onCloses={closeModal} onLoginStateChange={handleLoginStateChange} />
    </>
  );
};
export default AudiosPage;
